import React, { Component, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";

import { useTheme } from "../../../hooks";
import {
  Button,
  CurveHolder,
  StyledText,
} from "../../../components/common/basic";
import { Curve } from "../../../components/svgs";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

const CapturenShareSubmit = () => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "CaptureAndShareSubmit",
        firebase_screen_class: "CaptureAndShareSubmit",
      })
    );
  }, []);

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  return (
    <>
      <Children>
        <Header>
          <Image
            src={`${url}/assets/images/capture_n_share_feb-23.jpg`}
          />
          <Gradient />
        </Header>
        <CurveHolder style={{ zIndex: 1, position: "relative" }}>
          <Curve fill={"white"} />
        </CurveHolder>
        <Body>
          <BodyContent>
            <StyledText size={24}>{`Submitted!`}</StyledText>
            <StyledText
              size={16}
              style={{ textAlign: "center" }}
            >{`Submitted! Your Capture has been successfully submitted. You will be notified via call from 0244300000 for your prize after validation.`}</StyledText>
          </BodyContent>
          <BodyFooter>
            <Button
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={() => {
                const token = JSON.parse(localStorage.getItem("token"));

                history.push(`/home?token=${token}`);
              }}
              color={background}
            >
              <StyledText color={"white"}>{"Go Home"}</StyledText>
            </Button>
          </BodyFooter>
        </Body>
      </Children>
    </>
  );
};

const Children = styled.div`
  max-height: 700px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  width: 100%;
  height: 300px;
  overflow: hidden;
  position: relative;
`;

const Gradient = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
  padding: 5px;
`;

const Image = styled.img`
  width: 100%;
  height: 400px;
  margin: 0 0 0 0px;
  position: absolute;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: 20px;
`;

const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BodyFooter = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default CapturenShareSubmit;
